<div class="py-5 flex-1">
  <div class="table-header table-header-offset table-header-with-controls">
    <div class="table-header-controls flex-end gap-4">
      <div class="list-filters">
        <button type="button" appRemoveFocus class="table-header-filter-btn" (click)="filterMenu.toggle($event)" #filterBtn>
          <rkt-icon name="filter" class="table-header-filter-icon"></rkt-icon>
          Filter
          @if (activeFiltersCount) {
            <span class="table-header-filter-counter">{{ activeFiltersCount }}</span>
          }
        </button>
      </div>
      <button rktButton title="Create Fund On Hold" (click)="createFundOnHold()">Create</button>
    </div>
  </div>

  <div class="funds-on-hold-list">
    <rkt-table
      class="funds-on-hold-list-table"
      [rows]="fundsOnHold"
      [columns]="columns"
      [limit]="10"
      [count]="totalElements"
      (fetchData)="getFundsOnHold($event)"
      [loadingIndicator]="isLoading"
      [offset]="activePage"
      [rowHeight]="64"
      [isItemsAlignCenter]="true"
      [messages]="{ emptyMessage: emptyListMessage }"
      emptyValuePlaceholder="--"
      dateTimeFormat="MM/dd/yy HH:mm"
      (rowActivated)="onRowClick($event)"
      [sortParam]="sortParams"
    ></rkt-table>
  </div>

  <app-filter-menu
    #filterMenu
    [initialValues]="activeFilters"
    [filters]="filters"
    (opened)="filterBtn.classList.add('opened')"
    (closed)="filterBtn.classList.remove('opened')"
    (saved)="applyFilters($event)"
  >
  </app-filter-menu>
</div>
